import { render, staticRenderFns } from "./MediakitCollectionNotifications.vue?vue&type=template&id=e3a34110&"
import script from "./MediakitCollectionNotifications.vue?vue&type=script&lang=js&"
export * from "./MediakitCollectionNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports